<template>
  <div id="app">
     <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view />
  </div>
</template>

<script>
import { HTTP } from "./helpers/http-common";
export default {
  name: "App",
  created() {
    HTTP.interceptors.response.use(
      (response) => {
        return response;
      },
      function (error) {
        if (error.response.status === 401) {
          this.$store.dispatch("login/logout");
        }
         return Promise.reject(error);
      }
    );
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.logo{
  margin-bottom:15px;
  width:200px;
  .ql-container{
    height:0 !important;   
    .ql-editor{
      visibility: hidden !important;
      z-index: -100 !important;
    } 
  }   
}
</style>
